import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import { Seo } from "@/seo/Seo";

export default function Continue() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6">
      <Seo noindex path="/continue" title="Assessment Pending · AIROTECH" />
      <div className="max-w-lg text-center">
        <img src="/airotech-mark.png" alt="AIROTECH" className="h-11 w-auto mx-auto mb-10" />
        <span className="inline-flex h-12 w-12 rounded-full bg-cyan-400/10 border border-cyan-400/25 items-center justify-center mb-6">
          <Clock className="h-5 w-5 text-cyan-400" />
        </span>
        <h1 className="font-heading font-extrabold tracking-tighter text-3xl md:text-4xl">Your assessment is being prepared.</h1>
        <p className="mt-5 text-zinc-400 leading-relaxed">
          Thanks for taking the first step. The next stage of your product assessment isn't open yet —
          we'll be in touch by email with what happens next.
        </p>
        <button
          onClick={() => navigate("/")}
          className="mt-9 mono-label border border-[#232323] px-7 py-3.5 rounded-full hover:border-cyan-400/50 hover:text-cyan-300 transition-colors duration-200"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
